import * as React from "react";

function ReportsIcon({ width = 24.211, height = 25.059, ...props }) {
    return (
        <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
                <g className="anticon">
                    <rect width="5" height="18" x="16" y="3" rx="2" />
                    <rect width="5" height="12" x="9.5" y="9" rx="2" />
                    <rect width="5" height="5" x="3" y="16" rx="2" />
                </g>
            </svg>
        </span>
    );
}

export default ReportsIcon;

